module.exports = __webpack_public_path__ + "files/640c67d02ace1f33786ae8a27151e234.png";